import ToolData from './ToolData';
export default ToolData;
